import type { CSSProperties, ReactNode } from 'react';
import { color, radius } from './tokens';

export interface CardProps {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  padded?: boolean;
  style?: CSSProperties;
}

/** White bordered panel with an optional header row. */
export function Card({ title, action, children, padded = true, style }: CardProps) {
  return (
    <section
      style={{
        background: color.surface,
        border: `1px solid ${color.border}`,
        borderRadius: radius.card,
        boxSizing: 'border-box',
        minWidth: 0,
        ...style,
      }}
    >
      {(title || action) && (
        <header
          style={{
            padding: '16px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
          }}
        >
          {title && <h2 style={{ margin: 0, fontSize: 16 }}>{title}</h2>}
          {action}
        </header>
      )}
      <div style={padded ? { padding: title ? '0 20px 16px' : '16px 20px' } : undefined}>
        {children}
      </div>
    </section>
  );
}
